import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Roadmaps = () => {
  return (
    <section className="py-24 px-6 bg-slate-900/30">
      <div className="max-w-6xl mx-auto">
        
        {/* 90 DAY PLAN */}
        <div className="mb-32">
          <div className="text-center mb-16">
            <span className="text-amber-500 font-bold uppercase tracking-widest text-xs">Phased Implementation</span>
            <h2 className="text-3xl md:text-5xl font-black text-white mt-2">The 90-Day Implementation Sprint</h2>
            <p className="text-slate-400 mt-4">How we ensure you actually complete the courses and build your OS.</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 relative">
            <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-slate-800 -translate-y-1/2 z-0"></div>
            {[
              { 
                day: "Month 1", 
                title: "Foundation & Lead Gen", 
                desc: "Complete Pillars 1, 2 & 7. Set up your AI Consulting offer and launch your first automated traffic engine.",
                icon: FiIcons.FiTarget 
              },
              { 
                day: "Month 2", 
                title: "Systems & Automation", 
                desc: "Complete Pillars 3 & 4. Install GHL, WhatsApp automation, and your high-converting sales funnel.",
                icon: FiIcons.FiCpu 
              },
              { 
                day: "Month 3", 
                title: "Authority & Scaling", 
                desc: "Complete Pillars 5, 6 & 8. Launch your community, publish your authority assets, and begin scaling ads.",
                icon: FiIcons.FiTrendingUp 
              }
            ].map((step, i) => (
              <div key={i} className="relative z-10 bg-slate-950 p-8 rounded-3xl border border-slate-800 hover:border-amber-500/30 transition-all group">
                <div className="w-12 h-12 bg-amber-500 text-black rounded-full flex items-center justify-center font-black mb-6 group-hover:scale-110 transition-transform">
                  <SafeIcon icon={step.icon} />
                </div>
                <h4 className="text-amber-500 font-bold mb-2 uppercase tracking-tighter">{step.day}</h4>
                <h3 className="text-xl font-bold text-white mb-4">{step.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 12 MONTH EARNING ROADMAP */}
        <div className="bg-slate-950 p-8 md:p-16 rounded-[3rem] border border-amber-500/10 shadow-3xl">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-black text-white">The 1 Crore Revenue Blueprint</h2>
            <p className="text-slate-400 mt-4">A realistic 12-month trajectory for elite entrepreneurs.</p>
          </div>

          <div className="space-y-6">
            {[
              { stage: "Phase 1: Validation (Months 1-3)", target: "₹1L - ₹3L / Month", task: "Focus on 'High Ticket' AI Consulting. Master 1 traffic source. 1 simple funnel." },
              { stage: "Phase 2: Automation (Months 4-6)", target: "₹3L - ₹10L / Month", task: "Hire 1-2 assistants. Automate 80% of backend. Focus on webinar conversions." },
              { stage: "Phase 3: Scaling (Months 7-9)", target: "₹10L - ₹30L / Month", task: "Aggressive FB/YT ads. Launch your Skool community. Multi-channel traffic." },
              { stage: "Phase 4: Optimization (Months 10-12)", target: "₹30L - ₹1Cr+ / Year", task: "Build your internal sales team. Launch recurring membership. Exit daily operations." }
            ].map((phase, i) => (
              <div key={i} className="flex flex-col md:flex-row gap-6 items-start md:items-center p-6 bg-slate-900/50 rounded-2xl border border-slate-800 hover:bg-slate-900 transition-colors">
                <div className="flex-1">
                  <h4 className="text-white font-bold text-lg">{phase.stage}</h4>
                  <p className="text-slate-500 text-sm mt-1">{phase.task}</p>
                </div>
                <div className="bg-amber-500/10 border border-amber-500/20 px-6 py-3 rounded-xl text-amber-500 font-black text-xl whitespace-nowrap">
                  {phase.target}
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Roadmaps;